import { $hasFeature, $can, $isRole } from '@/core/utils/VueAcl'

export default {
  sectionName: 'LeftNavigation_CustomerIntelligence',
  icon: 'customer-intelligence',
  index: '6',
  isAllowed: () =>
    $hasFeature('intelligenceAccessible') &&
    !$isRole('consent-customer-service-agent'),
  withSubmenu: () => $hasFeature('metabase'),
  routeName: 'CustomerIntelligence',
  subItems: [
    {
      sectionName: 'LeftNavigation_CustomerIntelligence_Overview',
      index: '6-1',
      routeName: 'CustomerIntelligence'
    },
    {
      sectionName: 'LeftNavigation_CustomerIntelligence_Studio',
      index: '6-2',
      routeName: 'MetabaseProjectApplication',
      isAllowed: () =>
        $can('MetabaseProject:ReadAccess') && $hasFeature('hasMetabaseAccess')
    },
    {
      sectionName: 'LeftNavigation_CustomerIntelligence_Dashboards',
      index: '6-3',
      routeName: 'MetabaseDashboardList',
      subRouteName: ['MetabaseDashboard']
    },
    {
      sectionName: 'LeftNavigation_CustomerIntelligence_Computations',
      index: '6-4',
      routeName: 'MetabaseComputationList',
      isAllowed: () => $can('MetabaseComputation:ReadAccess')
    }
  ],
  isNew: false
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/customer-intelligence.js